import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function TracksIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g fill={color}>
        <path d="m20.85 6.06804c-1.8492.15329-5.2125.38203-8.85.38203-3.6374 0-7.00075-.22874-8.84995-.38203v10.05236c1.75626-.1537 4.92342-.3703 8.84995-.3703l.7325.0029.3152.0023.2813.1413c.7416.3726 2.0184 1.0133 2.9894 1.4935.4878.2412 1.0846.5408 1.6518.8244v-2.3103l1.4443.1013c.5481.0384 1.0293.0765 1.4355.1114zm1.35 10.86156c0 .3598-.3122.6406-.6703.6052-.4931-.0487-1.2449-.1153-2.2095-.1828v2.0742c0 .4468-.4703.7371-.8696.5368-.7747-.3889-1.9097-.9571-2.7304-1.3629-.9754-.4823-2.2556-1.1245-2.9971-1.4971-.2379-.0016-.479-.0029-.7231-.0029-4.5832 0-8.11616.298-9.52905.4388-.35828.0357-.67081-.2452-.6709-.6052v-11.67718c0-.3565.30827-.6355.66328-.60293 1.49672.13729 5.33511.44648 9.53667.44648 4.2017 0 8.04-.30919 9.5368-.44648.355-.03257.6632.24643.6632.60293z" />
        <path d="m13.05 13.125v1.35h-1.2v-1.35z" />
        <path d="m6.90005 10.425v1.35h-2.4v-1.35z" />
        <path d="m10.5 13.125v1.35h-5.99995v-1.35z" />
        <path d="m15.45 10.425v1.35h-7.19995v-1.35z" />
      </g>
    </SVGWrapper>

  );
}

export default TracksIcon;
